const BRAND_INDEXES = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").concat("#");

const normalizeInitial = (value) => {
  const initial = String(value || "").trim().charAt(0).toUpperCase();
  return /^[A-Z]$/.test(initial) ? initial : "#";
};

const compareBrands = (left, right) => {
  const initialDifference = BRAND_INDEXES.indexOf(left.initial)
    - BRAND_INDEXES.indexOf(right.initial);
  return initialDifference || left.name.localeCompare(right.name);
};

const normalizeBrands = (records) => {
  if (!Array.isArray(records)) return [];

  return records
    .filter((item) => item && item.id && item.umzljbzgr6tam3tx)
    .map((item) => ({
      id: item.id,
      businessId: item.aydaae7ta23jck0a,
      name: item.umzljbzgr6tam3tx,
      initial: normalizeInitial(item.xnovlurpoahjxwbw),
    }))
    .sort(compareBrands);
};

const groupBrands = (brands) => BRAND_INDEXES.reduce((groups, initial) => {
  const items = (Array.isArray(brands) ? brands : [])
    .filter((brand) => brand.initial === initial);
  if (items.length) groups.push({ initial, brands: items });
  return groups;
}, []);

module.exports = { BRAND_INDEXES, normalizeBrands, groupBrands };



// WEBPACK FOOTER //
// ./src/util/brandIndex.js